import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import LoanDetailsScreen from './LoanDetails';
import Form from './Form';
import Dashboard from './Dashboard';
import Interest from './Interests';
import Login from './Login';
import Header from './Header';
import Footer from './Footer';
import Reports from './Reports';

// Protected Route Component
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('accessToken');
  return token ? children : <Navigate to="/login" replace />;
}

// Public Route Component (redirect to dashboard if already logged in)
function PublicRoute({ children }) {
  const token = localStorage.getItem('accessToken');
  return token ? <Navigate to="/loans" replace /> : children;
}

function AppContent() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('loans');
  const [user, setUser] = useState({ name: 'User', role: 'User' });

  // Update activeTab based on current route
  useEffect(() => {
    const path = location.pathname;
    
    if (path === '/dashboard') {
      setActiveTab('dashboard');
    } else if (path === '/interest') {
      setActiveTab('interest');
    } else if (path === '/form') {
      setActiveTab('form');
    } else if (path === '/reports') {
      setActiveTab('reports');
    } else if (path === '/loans' || path === '/') {
      setActiveTab('loans');
    } else {
      // Default to loans for any unmatched routes within protected area
      setActiveTab('loans');
    }
    
  }, [location.pathname]);

  // Load user data from localStorage
  useEffect(() => {
    const savedUserData = localStorage.getItem('userData');
    if (savedUserData) {
      try {
        const userData = JSON.parse(savedUserData);
        setUser({
          name: userData.name || userData.userName || 'User',
          role: userData.role || (userData.userType === 'EU' ? 'End User' : 'Admin')
        });
      } catch (error) {
        console.error('Error parsing user data:', error);
        setUser({ name: 'User', role: 'User' });
      }
    }
  }, []);

  // Callback function to update user state after login
  const handleLoginSuccess = (userData) => {
    setUser(userData);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/* Public route - Login */}
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <Login onLoginSuccess={handleLoginSuccess} />
            </PublicRoute>
          } 
        />
        
        {/* Protected routes */}
        <Route 
          path="/*" 
          element={
            <ProtectedRoute>
              <div className="flex">
                <Sidebar 
                  activeTab={activeTab} 
                  setActiveTab={setActiveTab}
                />
                <div className="flex-1">
                  <Header user={user} />
                  <main className="p-4">
                    <Routes>
                      <Route path="/" element={<Navigate to="/loans" replace />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/loans" element={<LoanDetailsScreen />} />
                      <Route path="/interest" element={<Interest />} />
                      <Route path="/form" element={<Form />} />
                      <Route path="/reports" element={<Reports />} />
                    </Routes>
                  </main>
                  <Footer />
                </div>
              </div>
            </ProtectedRoute>
          } 
        />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}